export const HEX_CODE_REGEX = /^#[0-9A-F]{6}$/i
export const VALID_HEX_PARTIAL = /^#?[0-9A-F]{0,6}$/i

// MUI asserts the value of all inputs is unknown
export const filterColor = (value: unknown, allowEmpty: boolean): string | undefined => {
  if (value && typeof value === 'string' && validateHex(value)) return value
  else return allowEmpty ? '' : '#FFFFFF'
}

export const validateHex = (possibleColor: string): boolean => HEX_CODE_REGEX.test(possibleColor)
